import { Button } from '@/components/ui/button.jsx'
import { Icon } from '@iconify/react'
import { useDashboardContext } from '@/context-state/DashboardContext.jsx'
import { CreativePreview } from '@/pages/dashboard/library/creative/CreativePreview.jsx'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { handleError } from '@/services/errorHandler.js'
import { createFolder } from '@/services/api.js'
import { toggleLoader } from '@/hooks/useDashboardLoader.jsx'
import { TypographySmall } from '@/components/ui/typography.jsx'
import { useNavigate, useParams } from 'react-router-dom'
import { AdAccountSelect } from '@/components/ad-account-select/AdAccountSelect.jsx'

export const LibrarySubNavbar = () => {

    const { creativeContext, adAccountsContext } = useDashboardContext()
    const { updateFolderState, getAllFoldersFromState, getCreativesOfFolderFromState } = creativeContext
    const { chosenAdAccount } = adAccountsContext
    const [creativeToPreview, setCreativeToPreview] = useState(null)
    const topLevelFolders = getAllFoldersFromState().filter(folder => !folder.parent)
    const { folderId } = useParams()
    const navigate = useNavigate()


    const foldersToDisplay = topLevelFolders
        .filter(folder => folder.adAccountId && folder.adAccountId === chosenAdAccount)

    const createFolderCreative = async () => {
        try {
            if (!chosenAdAccount) {
                return
            }
            toggleLoader(true)
            const { data } = await createFolder({ name: 'New Folder', adAccountId: chosenAdAccount })
            updateFolderState([data])
            toast.success('Folder created successfully')
        } catch (e) {
            console.error(e)
            toast.error(e.message)
            handleError(e)
        } finally {
            toggleLoader(false)
        }
    }

    const navigateToLibraryRoot = () => {
        const currentPath = window.location.pathname; // Use `useLocation` to get this
        if (currentPath.endsWith('library')) {
            return
        }
        const newPath = currentPath.split('/').slice(0, -1).join('/'); // Remove last path name which will be the folderId - '/library/:folderId' and navigate back to '/library'
        navigate(newPath)
    }

    return (
        <div className="p-4">
            {
                creativeToPreview && (
                    <CreativePreview
                        onClose={() => setCreativeToPreview(null)}
                        creative={creativeToPreview}
                        isOpen={!!creativeToPreview}
                    />
                )
            }
            <div>

                <AdAccountSelect />

                <Button variant="primary-ghost" className="w-full justify-start gap-2 mb-2 px-2" onClick={createFolderCreative}>
                    <Icon icon="icons8:plus" className="h-4 w-4" />
                    Add Folder
                </Button>



                <div className={`cursor-pointer transition-colors hover:bg-accent p-2 rounded ${!folderId ? 'bg-accent' : ''}`} onClick={navigateToLibraryRoot}>
                    <TypographySmall className="flex items-center gap-2 font-light">
                        <Icon icon="solar:folder-with-files-linear" />
                        All Assets
                    </TypographySmall>
                </div>


                {
                    foldersToDisplay.length > 0 && (
                        <div className="flex flex-col gap-2 pl-2 mt-2">
                            {
                                foldersToDisplay.map((folder, index) => {
                                    const creatives = getCreativesOfFolderFromState(folder._id)
                                    return (
                                        <div key={index} className={`cursor-pointer transition-colors hover:bg-accent p-2 rounded ${folderId === folder._id ? 'bg-accent' : ''}`} onClick={() => navigate(`library/${folder._id}`)}>
                                            <TypographySmall className="flex items-center gap-2 font-light">
                                                <Icon icon="solar:folder-with-files-linear" />
                                                {folder.name}
                                                <span className="text-xsm text-muted-foreground">
                                                    {creatives.length ? `(${creatives.length})` : null}
                                                </span>
                                            </TypographySmall>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                }
            </div>


        </div>
    )
}